//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
import "../no/SelectNXObject.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
let d=[[[1,"Attachment",0,"SelectNXObject",0],[0,"AttachmentFrame",1,"CoordinateSystem",0],[0,"AttachmentType",1,0],[1,"DistanceFromStart",0,"Expression",0],[1,"MaxRetractedLength",0,"Expression",0],[1,"MinRetractedLength",0,"Expression",0],[1,"RollerCylindricalFace",0,"SelectNXObject",0],[0,"RotationAxis",1,0],[0,"SecondaryAttachmentFrame",1,"CoordinateSystem",0],[1,"SecondaryDistanceFromStart",0,"Expression",0],[1,"SpringConstant",0,"Expression",0],[1,"WindingLength",0,"Expression",0],[1,"WindingWidth",0,"Expression",0],[0,"WindingWidthType",1,0]],[],[]];
SPLM.Mechatronics.FlexibleCableAttachmentBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.FlexibleCableAttachmentBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.FlexibleCableAttachmentBuilder.AttachmentTypes = Object.freeze({
    "Fixed" : "Fixed", "Rotating" : "Rotating", "RotatingSliding" : "RotatingSliding", "RetractSystemType1" : "RetractSystemType1", "RetractSystemType2" : "RetractSystemType2", "RetractSystemType3" : "RetractSystemType3", "Roller" : "Roller"});

SPLM.Mechatronics.FlexibleCableAttachmentBuilder.RotationAxes = Object.freeze({
    "X" : "X", "Y" : "Y", "Z" : "Z", "All" : "All", "None" : "None"});

SPLM.Mechatronics.FlexibleCableAttachmentBuilder.WindingWidthTypes = Object.freeze({
    "RollerWidth" : "RollerWidth", "CableWidth" : "CableWidth", "UserDefined" : "UserDefined"});

export default SPLM;